




import { Component, Vue } from 'vue-property-decorator';
import { getUrlParam, isRunInWebview } from '@/utils/common';
import merchantApi from '@/api/merchant';
import { ServerResponse } from '@/interface/common';
import { GoodsInfoObj } from '@/interface/merchant';

@Component({
  name: 'QiYuService'
})

export default class QiYuService extends Vue {
  goodsInfo: GoodsInfoObj = {
    id: '',
    title: '',
    desc: '',
    picture: '',
    note: '',
    url: '',
  };
  created() {
    document.title = '在线客服';
    this.initService();
  }

  beforeDestroy() {
    window.removeEventListener('popstate', this.goBackToEntry);
  }

  pushHistory() {
    const state = {
      url: '#online-service'
    };

    window.history.pushState(state, '在线客服', '#online-service');
  }
  // 获取商品数据
  getGoodsDetail(): Promise<GoodsInfoObj> {
    return new Promise<GoodsInfoObj>((resolve, reject) => {

      const itemId = getUrlParam('itemId');

      if (!itemId) {
        return;
      }

      this.$http({
        url: `${merchantApi.getGoodsDetail.url}/${itemId}`,
        method: merchantApi.getGoodsDetail.method
      }).then((res: ServerResponse) => {
        return resolve(res.data)
      })
    });

  }

  goBackToEntry() {
    if (isRunInWebview()) {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      uni.navigateBack();
    } else {
      window.history.go(-2);
    }
  }

  initService() {
    (function (w, d, n, a, j) {
      w[n] = w[n] || function () {
        // eslint-disable-next-line prefer-rest-params
        (w[n].a = w[n].a || []).push(arguments);
      };
      // @ts-ignore
      j = d.createElement('script');
      // @ts-ignore
      j.async = true;
      // 添加subdomain=1会自动将qiyukf.com转为，公司的二级域名xunguangyunqian.qiyukf.com
      // @ts-ignore
      j.src = 'https://qiyukf.com/script/817b2ce87a5118fe92e7d3dd40868b1b.js?subdomain=1';
      // @ts-ignore
      d.body.appendChild(j);
    })(window, document, 'ysf');

    const phoneNumber = getUrlParam('phone');

    // Android
    if (location.hash === '#online-service') {
      this.goBackToEntry();

      return;
    }

    // iOS
    window.addEventListener('popstate', this.goBackToEntry);

    this.pushHistory();
    // @ts-ignore
    ysf('config', {
      uid: phoneNumber, // 用户名称  uid必须有，不然下面的参数不会生效
      name: getUrlParam('nickName'), // 用户名称
      mobile: phoneNumber, // 用户手机号
      robotId: getUrlParam('robotId'),
      groupid: getUrlParam('groupid'),
      robotShuntSwitch: 1,
      success: async () => { // 成功回调
        if (getUrlParam('itemId')&&getUrlParam('itemId')!=='undefined') {
          this.goodsInfo = await this.getGoodsDetail()
          // @ts-ignore
          ysf('product', {
            show: 1, // 1为打开， 其他参数为隐藏（包括非零元素）
            sendByUser: 1, // 是否由访客手动发送，1为是，其他参数为否
            template: getUrlParam('templateId'),
            title: this.goodsInfo.title,
            desc: this.goodsInfo.desc,
            picture: this.goodsInfo.picture,
            note: this.goodsInfo.note,
            success: () => {     // 成功回调
              // @ts-ignore
              ysf('open', {
                templateId: getUrlParam('templateId')
              });
            },
            error: () => {       // 错误回调
              // handle error
            }
          })
        } else {
          // @ts-ignore
          ysf('open', {
            templateId: getUrlParam('templateId')
          });
        }


      },
      error: () => {  // 错误回调
        // handle error
      }
    });
  }
}
